import React from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import InputGroup from "react-bootstrap/InputGroup";
import FormTexts from "../../../../constants/forms";
import Constants from "../../../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner, faTimes } from "@fortawesome/free-solid-svg-icons";
import { formsButtonType, formsPlaceHolderType } from "../../../../enums";
const SearchForm = (props) => {
  return (
    <Form
      onSubmit={(e) =>
        props.doTheSearch(e, {
          Conditions: props.conditions,
          NidInquiryStatuses: props.filter,
          PageSize: Constants.searchPagesLength,
          PageIndex: props.selectedPageIndex,
          SendCountResult: true,
        })
      }
      className="search-box"
    >
      {!props.showSpinner ? (
        <Button type="submit" className="mb-2">
          {FormTexts.Buttons(formsButtonType.Search())}
        </Button>
      ) : (
        <Button className="mb-2">
          <FontAwesomeIcon icon={faSpinner} spin />
        </Button>
      )}
      <Dropdown>
        <Dropdown.Toggle variant="success">
          {props.dropDownFilter}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {props.dropDownItems.map((d, index) => (
            <Dropdown.Item
              href={void 0}
              key={index}
              onClick={() => {
                props.setDropDownFilter(d);
                props.setFilterValue(index);
              }}
            >
              {d}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
      <InputGroup className={!props.emptySearch && "text-added"}>
        {props.emptySearch && (
          <InputGroup.Text
            className="empty"
            onClick={() => props.emptySearchInput()}
          >
            <FontAwesomeIcon icon={faTimes} />
          </InputGroup.Text>
        )}
        <Form.Control
          ref={props.searchedText}
          className={
            props.emptySearch
              ? "mb-2 normal-input added-times"
              : "mb-2 normal-input"
          }
          value={props.searchTerm}
          onChange={(e) => props.searchInputChange(e)}
          placeholder={FormTexts.PlaceHolders(formsPlaceHolderType.Search())}
        />
      </InputGroup>
    </Form>
  );
};
export default SearchForm;
